import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'formType',
    standalone: false
})
export class FormTypePipe implements PipeTransform {
  constructor() {
  }

  transform(txt: any) {
    if (txt === 'living_will') {
      return 'Living Will';
    } else if (txt === 'hcpoa') {
      return 'Healthcare POA';
    } else if (txt === 'mhcpoa') {
      return 'Mental HC POA';
    } else if (txt === 'prehospital') {
      return 'Prehospital Care Directive';
    } else if (txt === 'POLST') {
      return 'POLST';
    } else if (txt === 'AD') {
      return 'Advance Directive';
    } else if (txt === 'patient-upload') {
      return 'Patient Upload';
    } else if (txt === 'batch') {
      return 'Batch';
    } else if (txt === 'invalid') {
      return 'Non Advance Directive';
    } else if (txt.startsWith('id')) {
      return  txt;
    } else if (txt === 'pt-upload') {
      return 'Patient Upload';
    } else if (txt === 'dpoa') {
      return 'Durable Power of Attorney';
    } else if (txt === 'ahd') {
      return 'Advance Healthcare Directive';
    } else if (txt === 'non-acp') {
      return 'Non ACP';
    }
    return 'Unknown form type';
  }

}
